'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var vue = require('vue');

var LnApp = vue.defineComponent({
    name: "LnApp",
    render() {
        return vue.h('div', { 'ln-app': true, class: 'ln-app' }, this.$slots.default ? this.$slots.default() : []);
    }
});

var utils = {
    methods: {
        getDefaultSlot() {
            return this.$slots.default ? this.$slots.default() : () => [];
        },
        genId() {
            return Math.floor(Math.random() * 100000).toString();
        }
    }
};

var styleable = {
    data() {
        return {
            _width: this.width,
            _height: this.height,
            _borderRadius: this.borderRadius
        };
    },
    props: {
        primaryColor: Boolean,
        accentColor: Boolean,
        interactionColor: Boolean,
        shadow: {
            type: Boolean,
            required: false
        },
        height: {
            type: String || null,
            required: false
        },
        width: {
            type: String || null,
            required: false
        },
        borderRadius: {
            type: String || null,
            required: false
        }
    },
    computed: {
        styleableClasses() {
            return {
                'primary-color': this.primaryColor,
                'accent-color': this.accentColor,
                'interaction-color': this.interactionColor,
                'shadow': this.shadow
            };
        }
    },
    methods: {
        proceedWidth() {
            if (this.width) {
                this.$el.style.width = this.width + (/^\d+$/.test(this.width) ? 'px' : '');
                this._width = this.width + (/^\d+$/.test(this.width) ? 'px' : '');
            }
        },
        proceedHeight() {
            if (this.height) {
                this.$el.style.height = this.height + (/^\d+$/.test(this.height) ? 'px' : '');
                this._height = this.height + (/^\d+$/.test(this.height) ? 'px' : '');
            }
        },
        proceedBorderRadius() {
            if (this.borderRadius) {
                this.$el.style.borderRadius = this.borderRadius + (/^\d+$/.test(this.borderRadius) ? 'px' : '');
                this._borderRadius = this.borderRadius + (/^\d+$/.test(this.borderRadius) ? 'px' : '');
            }
        }
    },
    watch: {
        width() {
            this.proceedWidth();
        },
        height() {
            this.proceedHeight();
        },
        borderRadius() {
            this.proceedBorderRadius();
        }
    },
    mounted() {
        this.proceedWidth();
        this.proceedHeight();
        this.proceedBorderRadius();
    },
};

var gridable = {
    props: {
        xs: {
            type: [Number, String],
            default: null
        },
        sm: {
            type: [Number, String],
            default: null
        },
        md: {
            type: [Number, String],
            default: null
        },
        lg: {
            type: [Number, String],
            default: null
        },
        xl: {
            type: [Number, String],
            default: null
        },
        offsetXs: {
            type: [Number, String],
            default: null
        },
        offsetSm: {
            type: [Number, String],
            default: null
        },
        offsetMd: {
            type: [Number, String],
            default: null
        },
        offsetLg: {
            type: [Number, String],
            default: null
        },
        offsetXl: {
            type: [Number, String],
            default: null
        },
        alignContentCenter: Boolean,
        wrap: Boolean,
        nowrap: Boolean,
        space: Boolean
    },
    computed: {
        gridableClasses() {
            return {
                'ln-grid-base': true,
                [`ln-grid-xs-${this.xs}`]: this.xs,
                [`ln-grid-sm-${this.sm}`]: this.sm,
                [`ln-grid-md-${this.md}`]: this.md,
                [`ln-grid-lg-${this.lg}`]: this.lg,
                [`ln-grid-xl-${this.xl}`]: this.xl,
                [`ln-grid-offset-xs-${this.offsetXs}`]: this.offsetXs,
                [`ln-grid-offset-sm-${this.offsetSm}`]: this.offsetSm,
                [`ln-grid-offset-md-${this.offsetMd}`]: this.offsetMd,
                [`ln-grid-offset-lg-${this.offsetLg}`]: this.offsetLg,
                [`ln-grid-offset-xl-${this.offsetXl}`]: this.offsetXl,
                'align-content-center': this.alignContentCenter,
                'wrap': this.wrap,
                'nowrap': this.nowrap,
                'space': this.space
            };
        }
    },
};

var hideable = {
    data() {
        return {
            _hideIn: typeof this.hideIn === 'string' ? this.getArrayFromString(this.hideIn) : this.hideIn
        };
    },
    props: {
        hideIn: {
            type: [String, Array],
            default: [],
            validator(values) {
                if (typeof values === 'string') {
                    return true;
                }
                else {
                    return values.filter((x) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(x)).length === values.length;
                }
            }
        }
    },
    computed: {
        hideableClasses() {
            return {
                'ln-hidden-xs': this._hideIn.includes('xs'),
                'ln-hidden-sm': this._hideIn.includes('sm'),
                'ln-hidden-md': this._hideIn.includes('lg'),
                'ln-hidden-lg': this._hideIn.includes('lg'),
                'ln-hidden-xl': this._hideIn.includes('xl')
            };
        }
    },
    methods: {
        getArrayFromString(value) {
            return value.split(/[\s,]+/);
        }
    }
};

var LnContainer = vue.defineComponent({
    mixins: [utils, styleable, gridable, hideable],
    name: "LnContainer",
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                ...this.gridableClasses,
                ...this.hideableClasses,
                'ln-container': true
            };
        }
    },
    render() {
        return vue.h('div', { class: this.classes }, [this.getDefaultSlot()]);
    }
});

var LnRow = vue.defineComponent({
    mixins: [utils, styleable, gridable, hideable],
    name: "LnRow",
    props: {
        justify: {
            type: String,
            default: 'start',
            validator(value) {
                return ['start', 'center', 'end', 'space-around', 'space-between'].includes(value);
            }
        },
        align: {
            type: String,
            default: 'start',
            validator(value) {
                return ['start', 'center', 'end'].includes(value);
            }
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                ...this.gridableClasses,
                ...this.hideableClasses,
                'ln-row': true,
                [`ln-justify-${this.justify}`]: this.justify,
                [`ln-align-${this.align}`]: this.align
            };
        }
    },
    render() {
        return vue.h('div', { class: this.classes }, [this.getDefaultSlot()]);
    }
});

var LnCol = vue.defineComponent({
    mixins: [utils, styleable, gridable, hideable],
    name: "LnCol",
    props: {
        justify: {
            type: String,
            default: 'start',
            validator(value) {
                return ['start', 'center', 'end', 'space-around', 'space-between'].includes(value);
            }
        },
        alignSelf: {
            type: String,
            default: null,
            validator(value) {
                return ['start', 'center', 'end'].includes(value);
            }
        },
        align: {
            type: String,
            default: null,
            validator(value) {
                return ['start', 'center', 'end'].includes(value);
            }
        }
    },
    computed: {
        classes() {
            return {
                ...this.gridableClasses,
                ...this.styleableClasses,
                ...this.hideableClasses,
                'ln-col': true,
                [`ln-align-self-${this.alignSelf}`]: this.alignSelf,
                [`ln-justify-${this.justify}`]: this.justify,
                [`ln-align-${this.align}`]: this.align
            };
        }
    },
    render() {
        return vue.h('div', { class: this.classes }, this.getDefaultSlot());
    }
});

var LnSpacer = vue.defineComponent({
    mixins: [utils, styleable, gridable, hideable],
    name: "LnSpacer",
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                ...this.gridableClasses,
                ...this.hideableClasses,
                'ln-spacer': true
            };
        }
    },
    render() {
        return vue.h('div', { class: this.classes }, () => []);
    }
});

var LnButton = vue.defineComponent({
    mixins: [styleable, utils],
    name: "LnButton",
    props: {
        loading: Boolean,
        disabled: Boolean,
    },
    methods: {
        onClickAction() {
            this.$emit('buttonClicked');
        },
        genTemplate() {
            return vue.h('button', {
                class: this.buttonClasses,
                onClick: this.onClickAction,
                disabled: this.loading || this.disabled
            }, [
                vue.h('span', {}, [
                    vue.h('span', {}, [this.getDefaultSlot()])
                ])
            ]);
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'button--wrapper': true,
            };
        },
        buttonClasses() {
            return {
                'loading': this.loading,
                'disabled': this.disabled,
                'active': !this.loading && !this.disabled
            };
        }
    },
    render() {
        return vue.h('div', { class: this.classes }, this.genTemplate());
    }
});

var LnFileSelector = vue.defineComponent({
    mixins: [styleable, utils],
    name: "LnFileSelector",
    props: {
        modelValue: {
            type: FileList,
            required: false
        },
        accept: {
            type: String,
            required: false
        },
        customLayout: Boolean
    },
    methods: {
        onFileChange(e) {
            this.$emit('update:modelValue', e.target.files);
        },
        getBackgroundImage(file) {
            return `background-image: url(${URL.createObjectURL(file)})`;
        },
        clearFileList() {
            this.$emit('update:modelValue', null);
        },
        genTemplate() {
            return [
                vue.h('label', {}, [
                    vue.h('input', { type: 'file', accept: this.accept, onChange: this.onFileChange }),
                    this.getDefaultSlot(),
                    vue.h('span', {}),
                ]),
                this.genDefaultFilePreview()
            ];
        },
        genDefaultFilePreview() {
            if (!this.customLayout) {
                return vue.h('div', {}, [this.genFilePreview()]);
            }
            else {
                return this.$slots.fileList ? this.$slots.fileList()[0] : vue.h('div', {}, []);
            }
        },
        genFilePreview() {
            let nodeList = [];
            if (this.modelValue) {
                for (let i = 0; i < this.modelValue.length; i++) {
                    nodeList.push(vue.h('div', { style: this.getBackgroundImage(this.modelValue[i]), onClick: this.clearFileList }, []));
                }
            }
            return nodeList;
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'ln-file-selector-wrapper': true,
            };
        },
    },
    render() {
        return vue.h('div', { class: this.classes }, this.genTemplate());
    }
});

var LnTextBox = vue.defineComponent({
    mixins: [styleable, utils],
    name: "LnTextBox",
    props: {
        modelValue: {
            type: String
        },
        placeholder: {
            type: String
        },
        height: {
            type: String || Number,
            default: '55'
        }
    },
    methods: {
        onFileChange(e) {
            this.$emit('update:modelValue', e.target.files);
        },
        getBackgroundImage(file) {
            return `background-image: url(${URL.createObjectURL(file)})`;
        },
        clearFileList() {
            this.$emit('update:modelValue', null);
        },
        genTemplate() {
            return [
                vue.h('label', {}, [
                    vue.h('input', { value: this.modelValue, onInput: (event) => { this.$emit('update:modelValue', event.target.value); } }),
                    vue.h('span', { innerHTML: this.placeholder }, [])
                ])
            ];
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'ln-text-box': true,
                'ln-text-box__filled': this.modelValue && this.modelValue.length > 0
            };
        },
    },
    render() {
        return vue.h('div', { class: this.classes, height: Number(this.height) < 55 ? '55' : this.height }, this.genTemplate());
    }
});

var LnFooter = vue.defineComponent({
    mixins: [utils, styleable],
    name: "LnFooter",
    data() {
        return {
            scrollFixed: false,
            appContainer: null,
            appContainerResizeObserver: null
        };
    },
    props: {
        fixed: Boolean
    },
    methods: {
        getLayout() {
            return [
                this.fixed && vue.h('div', { style: { height: this._height, width: this._width } }),
                vue.h('div', { style: { height: this._height, width: this._width }, class: this.styleableClasses }, this.getDefaultSlot())
            ];
        },
        onResize() {
            this.scrollFixed = window.innerHeight - this.appContainer.clientHeight > 0;
        }
    },
    computed: {
        classes() {
            return {
                'ln-footer': true,
                'ln-footer__fixed': this.fixed || this.scrollFixed
            };
        }
    },
    mounted() {
        if (!this.fixed) {
            this.appContainer = document.querySelector('[ln-app]');
            if (this.appContainer) {
                this.appContainerResizeObserver = new ResizeObserver(this.onResize);
                this.appContainerResizeObserver.observe(this.appContainer);
            }
        }
    },
    unmounted() {
        if (this.appContainerResizeObserver)
            this.appContainerResizeObserver.disconnect();
    },
    render() {
        return vue.h('div', { class: this.classes }, this.getLayout());
    }
});

var LnHeader = vue.defineComponent({
    mixins: [utils, styleable],
    name: "LnHeader",
    data() {
        return {
            id: this.genId()
        };
    },
    methods: {
        genTemplate() {
            return vue.h('div', { class: this.classes, style: { height: this._height } }, this.getDefaultSlot());
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'ln-header': true
            };
        }
    },
    render() {
        return vue.h('div', { class: 'ln-header__spacer', style: { height: this._height } }, this.genTemplate());
    }
});

const icons = {
    'close': 'M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z',
    'close-box': 'M19,3H16.3H7.7H5A2,2 0 0,0 3,5V7.7V16.4V19A2,2 0 0,0 5,21H7.7H16.4H19A2,2 0 0,0 21,19V16.3V7.7V5A2,2 0 0,0 19,3M15.6,17L12,13.4L8.4,17L7,15.6L10.6,12L7,8.4L8.4,7L12,10.6L15.6,7L17,8.4L13.4,12L17,15.6L15.6,17Z',
    'delete': 'M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z',
    'menu': 'M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z',
    'chevron-right': 'M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z',
    'chevron-left': 'M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z',
    'wrench-cog-outline': 'M9 1.09V6H7V1.09C4.16 1.57 2 4.03 2 7C2 9.22 3.21 11.15 5 12.19V21C5 21.55 5.45 22 6 22H10C10.55 22 11 21.55 11 21V12.19C12.79 11.15 14 9.22 14 7C14 4.03 11.84 1.57 9 1.09M10 10.46L9 11.04V20H7V11.04L6 10.46C4.77 9.74 4 8.42 4 7C4 6 4.37 5.06 5 4.35V8H11V4.35C11.63 5.06 12 6 12 7C12 8.42 11.23 9.74 10 10.46M20.94 17.94C20.96 17.79 20.97 17.65 20.97 17.5S20.96 17.2 20.94 17.05L21.91 16.32C22 16.25 22.03 16.13 21.97 16.03L21.05 14.47C21 14.37 20.87 14.33 20.76 14.37L19.61 14.82C19.37 14.65 19.12 14.5 18.83 14.38L18.66 13.19C18.64 13.08 18.54 13 18.43 13H16.58C16.46 13 16.36 13.08 16.34 13.19L16.17 14.38C15.88 14.5 15.63 14.65 15.39 14.82L14.24 14.37C14.14 14.33 14 14.37 13.96 14.47L13.03 16.03C12.97 16.13 13 16.25 13.09 16.32L14.06 17.05C14.05 17.2 14.03 17.35 14.03 17.5S14.05 17.79 14.06 17.94L13.09 18.68C13 18.75 12.97 18.87 13.03 18.97L13.96 20.53C14 20.63 14.14 20.66 14.24 20.63L15.39 20.17C15.63 20.35 15.88 20.5 16.17 20.62L16.34 21.81C16.36 21.92 16.46 22 16.58 22H18.43C18.54 22 18.64 21.92 18.66 21.81L18.83 20.62C19.12 20.5 19.37 20.35 19.61 20.17L20.76 20.63C20.87 20.66 21 20.63 21.05 20.53L21.97 18.97C22.03 18.87 22 18.75 21.91 18.68L20.94 17.94M17.5 19C16.67 19 16 18.33 16 17.5S16.67 16 17.5 16 19 16.67 19 17.5 18.33 19 17.5 19Z',
    'food-off': 'M11.35 8.5L11 5H16V1H18V5H23L21.62 18.79L11.35 8.5M1 21V22C1 22.55 1.45 23 2 23H15C15.55 23 16 22.55 16 22V21H1M21.9 21.9L2.1 2.1L.69 3.5L6.39 9.21C3.28 9.87 1 12 1 15H12.17L14.17 17H1V19H16V18.83L20.5 23.32L21.9 21.9Z',
    'microwave': 'M4,5A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V7A2,2 0 0,0 20,5H4M4,7H16V17H4V7M19,7A1,1 0 0,1 20,8A1,1 0 0,1 19,9A1,1 0 0,1 18,8A1,1 0 0,1 19,7M13,9V15H15V9H13M19,11A1,1 0 0,1 20,12A1,1 0 0,1 19,13A1,1 0 0,1 18,12A1,1 0 0,1 19,11Z',
    'bed-king': 'M6 5C5.47 5 5 5.21 4.59 5.6S4 6.45 4 7V10C3.45 10 3 10.19 2.6 10.59S2 11.47 2 12V17H3.33L4 19H5L5.67 17H18.33L19 19H20L20.67 17H22V12C22 11.47 21.79 11 21.4 10.59C21 10.19 20.55 10 20 10V7C20 6.45 19.81 6 19.41 5.6S18.53 5 18 5M6 7H11V10H6M13 7H18V10H13Z',
    'bunk-bed': 'M1 2V23H3V21H21V23H23V7C23 4.79 21.21 3 19 3H10V8H3V2M6.5 2A2.5 2.5 0 0 0 4 4.5A2.5 2.5 0 0 0 6.5 7A2.5 2.5 0 0 0 9 4.5A2.5 2.5 0 0 0 6.5 2M3 11H21V13.56C20.41 13.21 19.73 13 19 13H10V18H3M6.5 12A2.5 2.5 0 0 0 4 14.5A2.5 2.5 0 0 0 6.5 17A2.5 2.5 0 0 0 9 14.5A2.5 2.5 0 0 0 6.5 12Z',
    'sofa': 'M12.5 7C12.5 5.89 13.39 5 14.5 5H18C19.1 5 20 5.9 20 7V9.16C18.84 9.57 18 10.67 18 11.97V14H12.5V7M6 11.96V14H11.5V7C11.5 5.89 10.61 5 9.5 5H6C4.9 5 4 5.9 4 7V9.15C5.16 9.56 6 10.67 6 11.96M20.66 10.03C19.68 10.19 19 11.12 19 12.12V15H5V12C5 10.9 4.11 10 3 10S1 10.9 1 12V17C1 18.1 1.9 19 3 19V21H5V19H19V21H21V19C22.1 19 23 18.1 23 17V12C23 10.79 21.91 9.82 20.66 10.03Z',
    'television': 'M21,17H3V5H21M21,3H3A2,2 0 0,0 1,5V17A2,2 0 0,0 3,19H8V21H16V19H21A2,2 0 0,0 23,17V5A2,2 0 0,0 21,3Z',
    'speaker': 'M12,12A3,3 0 0,0 9,15A3,3 0 0,0 12,18A3,3 0 0,0 15,15A3,3 0 0,0 12,12M12,20A5,5 0 0,1 7,15A5,5 0 0,1 12,10A5,5 0 0,1 17,15A5,5 0 0,1 12,20M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8C10.89,8 10,7.1 10,6C10,4.89 10.89,4 12,4M17,2H7C5.89,2 5,2.89 5,4V20A2,2 0 0,0 7,22H17A2,2 0 0,0 19,20V4C19,2.89 18.1,2 17,2Z',
    'chess-knight': 'M19,22H5V20H19V22M13,2V2C11.75,2 10.58,2.62 9.89,3.66L7,8L9,10L11.06,8.63C11.5,8.32 12.14,8.44 12.45,8.9C12.47,8.93 12.5,8.96 12.5,9V9C12.8,9.59 12.69,10.3 12.22,10.77L7.42,15.57C6.87,16.13 6.87,17.03 7.43,17.58C7.69,17.84 8.05,18 8.42,18H17V6A4,4 0 0,0 13,2Z',
    'wifi': 'M12,21L15.6,16.2C14.6,15.45 13.35,15 12,15C10.65,15 9.4,15.45 8.4,16.2L12,21M12,3C7.95,3 4.21,4.34 1.2,6.6L3,9C5.5,7.12 8.62,6 12,6C15.38,6 18.5,7.12 21,9L22.8,6.6C19.79,4.34 16.05,3 12,3M12,9C9.3,9 6.81,9.89 4.8,11.4L6.6,13.8C8.1,12.67 9.97,12 12,12C14.03,12 15.9,12.67 17.4,13.8L19.2,11.4C17.19,9.89 14.7,9 12,9Z',
    'ruler-square': 'M3,5V21H9V19.5H7V18H9V16.5H5V15H9V13.5H7V12H9V10.5H5V9H9V5H10.5V9H12V7H13.5V9H15V5H16.5V9H18V7H19.5V9H21V3H5A2,2 0 0,0 3,5M6,7A1,1 0 0,1 5,6A1,1 0 0,1 6,5A1,1 0 0,1 7,6A1,1 0 0,1 6,7Z',
    'wardrobe': 'M4 4V19C4 20.1 4.9 21 6 21V22H8V21H11.5V2H6C4.9 2 4 2.9 4 4M8 10H10V13H8V10M18 2H12.5V21H16V22H18V21C19.1 21 20 20.1 20 19V4C20 2.9 19.1 2 18 2M16 13H14V10H16V13Z',
    'coffee-maker': 'M18 6V4H20V2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H20V20H15.97C17.2 19.09 18 17.64 18 16V11H8V16C8 17.64 8.81 19.09 10.03 20H6V4H8V6C8 6.55 8.45 7 9 7H17C17.55 7 18 6.55 18 6M13 8C13.55 8 14 8.45 14 9S13.55 10 13 10 12 9.55 12 9 12.45 8 13 8Z',
    'dishwasher': 'M18,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2M10,4A1,1 0 0,1 11,5A1,1 0 0,1 10,6A1,1 0 0,1 9,5A1,1 0 0,1 10,4M7,4A1,1 0 0,1 8,5A1,1 0 0,1 7,6A1,1 0 0,1 6,5A1,1 0 0,1 7,4M18,20H6V8H18V20M14.67,15.33C14.69,16.03 14.41,16.71 13.91,17.21C12.86,18.26 11.15,18.27 10.09,17.21C9.59,16.71 9.31,16.03 9.33,15.33C9.4,14.62 9.63,13.94 10,13.33C10.37,12.5 10.81,11.73 11.33,11L12,10C13.79,12.59 14.67,14.36 14.67,15.33',
    'fridge': 'M7,2H17A2,2 0 0,1 19,4V9H5V4A2,2 0 0,1 7,2M19,19A2,2 0 0,1 17,21V22H15V21H9V22H7V21A2,2 0 0,1 5,19V10H19V19M8,5V7H10V5H8M8,12V15H10V12H8Z',
    'grill': 'M8.06,2C7.88,3.17 8.17,4.16 8.95,4.97C9.45,5.47 9.61,6.14 9.42,7H10.41C10.53,6.45 10.55,6 10.45,5.55C10.36,5.13 10.05,4.63 9.5,4.03C9.05,3.47 8.89,2.8 9.05,2H8.06M10.55,2C10.36,3.17 10.66,4.16 11.44,4.97C11.94,5.47 12.09,6.14 11.91,7H12.89C13,6.45 13.03,6 12.94,5.55C12.84,5.13 12.53,4.63 12,4.03C11.53,3.47 11.38,2.8 11.53,2H10.55M13.08,2C12.89,3.17 13.19,4.16 13.97,4.97C14.47,5.47 14.61,6.14 14.39,7H15.42C15.55,6.45 15.56,6 15.47,5.55C15.38,5.13 15.06,4.63 14.53,4.03C14.06,3.47 13.91,2.8 14.06,2H13.08M5,8C5,9.42 5.39,10.7 6.14,11.84C6.87,12.96 7.91,13.85 9.14,14.39L5.16,20.44C5.06,20.56 5,20.75 5,21C5,21.41 5.16,21.69 5.44,21.84C5.56,21.94 5.75,22 6,22C6.41,22 6.69,21.84 6.84,21.56L7.83,19.97H14.2C14.41,20.55 14.79,21.05 15.28,21.42C15.78,21.8 16.36,22 17,22C17.83,22 18.53,21.69 19.13,21.09C19.72,20.5 20,19.8 20,19C20,18.17 19.72,17.47 19.13,16.88C18.53,16.28 17.83,16 17,16C16.36,16 15.78,16.17 15.28,16.55C14.78,16.92 14.42,17.41 14.2,18H9.14L11.11,14.95C11.27,15 11.56,15 12,15C12.44,15 12.73,15 12.89,14.95L13.88,16.5C14.29,15.96 14.84,15.54 15.47,15.28L14.91,14.39C16.03,13.89 17,13 17.79,11.77C18.59,10.5 19,9.27 19,8H5M17,18C17.3,18 17.53,18.09 17.72,18.28C17.91,18.47 18,18.72 18,19C18,19.27 17.91,19.5 17.72,19.71C17.54,19.91 17.28,20 17,20C16.74,20 16.5,19.91 16.29,19.71C16.09,19.5 16,19.26 16,19C16,18.7 16.09,18.47 16.29,18.28C16.5,18.09 16.73,18 17,18Z',
    'stove': 'M6,14H8L11,17H9L6,14M4,4H5V3A1,1 0 0,1 6,2H10A1,1 0 0,1 11,3V4H13V3A1,1 0 0,1 14,2H18A1,1 0 0,1 19,3V4H20A2,2 0 0,1 22,6V19A2,2 0 0,1 20,21V22H17V21H7V22H4V21A2,2 0 0,1 2,19V6A2,2 0 0,1 4,4M18,7A1,1 0 0,1 19,8A1,1 0 0,1 18,9A1,1 0 0,1 17,8A1,1 0 0,1 18,7M14,7A1,1 0 0,1 15,8A1,1 0 0,1 14,9A1,1 0 0,1 13,8A1,1 0 0,1 14,7M20,6H4V10H20V6M4,19H20V12H4V19M6,7A1,1 0 0,1 7,8A1,1 0 0,1 6,9A1,1 0 0,1 5,8A1,1 0 0,1 6,7M13,14H15L18,17H16L13,14Z',
    'toaster': 'M21 11A2 2 0 0 0 19 9H5A2 2 0 0 0 3 11H2V13H3V20H21V13H22V11M17 15A2 2 0 1 1 19 13A2 2 0 0 1 17 15M18 8H6C6.33 5.75 8.88 4 12 4S17.63 5.75 18 8Z',
    'tumble-dryer': 'M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M7,4A1,1 0 0,0 6,5A1,1 0 0,0 7,6A1,1 0 0,0 8,5A1,1 0 0,0 7,4M10,4A1,1 0 0,0 9,5A1,1 0 0,0 10,6A1,1 0 0,0 11,5A1,1 0 0,0 10,4M12,8A6,6 0 0,0 6,14A6,6 0 0,0 12,20A6,6 0 0,0 18,14A6,6 0 0,0 12,8M8.11,10.5H10C9.76,11.88 10,12.67 10.58,13.29C11.68,14.36 12.16,15.71 11.89,17.5H10C10.24,16.12 10,15.33 9.42,14.71C8.32,13.64 7.85,12.29 8.11,10.5M12.11,10.5H14C13.76,11.88 14,12.67 14.58,13.29C15.68,14.36 16.16,15.71 15.89,17.5H14C14.24,16.12 14,15.33 13.42,14.71C12.32,13.64 11.85,12.29 12.11,10.5Z',
    'iron': 'M21 6C19.34 6 18 7.34 18 9V13C18 13.55 17.55 14 17 14V10C17 8.34 15.66 7 14 7H10C8.34 7 7 8.34 7 10H9C9 9.45 9.45 9 10 9H14C14.55 9 15 9.45 15 10V11H6C3.79 11 2 12.79 2 15V18H17V16C18.66 16 20 14.66 20 13V9C20 8.45 20.45 8 21 8H22V6H21Z',
    'washing-machine': 'M14.83,11.17C16.39,12.73 16.39,15.27 14.83,16.83C13.27,18.39 10.73,18.39 9.17,16.83L14.83,11.17M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M7,4A1,1 0 0,0 6,5A1,1 0 0,0 7,6A1,1 0 0,0 8,5A1,1 0 0,0 7,4M10,4A1,1 0 0,0 9,5A1,1 0 0,0 10,6A1,1 0 0,0 11,5A1,1 0 0,0 10,4M12,8A6,6 0 0,0 6,14A6,6 0 0,0 12,20A6,6 0 0,0 18,14A6,6 0 0,0 12,8Z',
    'chair-school': 'M22,5V7H17L13.53,12H16V14H14.46L18.17,22H15.97L15.04,20H6.38L5.35,22H3.1L7.23,14H7C6.55,14 6.17,13.7 6.04,13.3L2.87,3.84L3.82,3.5C4.34,3.34 4.91,3.63 5.08,4.15L7.72,12H12.1L15.57,7H12V5H22M9.5,14L7.42,18H14.11L12.26,14H9.5Z',
    'map-marker': 'M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z',
    'camera': 'M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z',
    'pencil': 'M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z',
    'menu-down': 'M7,10L12,15L17,10H7Z'
};

var LnIcon = vue.defineComponent({
    mixins: [utils, styleable, hideable],
    name: "LnIcon",
    props: {
        icon: {
            type: String,
            default: ''
        },
        hover: Boolean,
        background: Boolean,
        width: {
            type: String || Number,
            default: '37'
        },
        height: {
            type: String || Number,
            default: '37'
        },
        fill: {
            type: String,
            required: false,
            default: 'interaction-color'
        }
    },
    methods: {
        genTemplate() {
            const svgData = {
                xmlns: 'http://www.w3.org/2000/svg',
                viewBox: '0 0 24 24',
                width: '65%',
                height: '65%',
                fill: this.getColorCode(this.fill)
            };
            return vue.h('svg', svgData, vue.h('path', { d: icons[this.icon ? this.icon : this.getDefaultSlotContent()] }, () => []));
        },
        getColorCode(colorName) {
            switch (colorName) {
                case ('primary-color'): return this.$primaryColor;
                case ('accent-color'): return this.$accentColor;
                case ('interaction-color'): return this.$interactionColor;
                default: return colorName;
            }
        },
        getDefaultSlotContent() {
            return (this.$slots.default && this.$slots.default()[0]) ? this.$slots.default()[0].children : '';
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                ...this.hideableClasses,
                'ln-icon': true,
                'ln-icon__background': this.background,
                'ln-icon__hover': this.hover
            };
        }
    },
    render() {
        return vue.h('div', { class: this.classes, style: { width: this.width, height: this.height } }, this.genTemplate());
    }
});

var LnImage = vue.defineComponent({
    mixins: [styleable, utils],
    name: "LnImage",
    props: {
        src: {
            type: String,
            required: true
        },
        lazySrc: {
            type: String,
            required: false,
            default: null
        },
        aspectRatio: {
            type: String,
            required: false,
            default: '1/1'
        },
        asImg: {
            type: Boolean,
            required: false,
            default: false
        },
        contain: Boolean
    },
    methods: {
        genTemplate() {
            return [
                vue.h(this.asImg ? 'img' : 'div', { class: 'ln-img-holder' }),
                vue.h('div', {}, () => [])
            ];
        },
        preloadImage() {
            setTimeout(() => {
                const img = new Image();
                img.src = this.src;
                img.onload = () => {
                    this.$el.classList.remove('ln-img__loading');
                    this.asImg ?
                        this.$el.getElementsByClassName('ln-img-holder')[0].setAttribute('src', this.src) :
                        this.$el.getElementsByClassName('ln-img-holder')[0].style.backgroundImage = `url(${this.src})`;
                };
            }, 100);
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'ln-img': true,
                'ln-img__contain': this.contain,
                'ln-img__cover': !this.contain,
                'ln-img__loading': this.lazySrc
            };
        }
    },
    mounted() {
        this.$el.style.aspectRatio = this.aspectRatio;
        if (this.lazySrc) {
            this.asImg ?
                this.$el.getElementsByClassName('ln-img-holder')[0].setAttribute('src', this.lazySrc) :
                this.$el.getElementsByClassName('ln-img-holder')[0].style.backgroundImage = `url(${this.lazySrc})`;
        }
        else {
            this.asImg ?
                this.$el.getElementsByClassName('ln-img-holder')[0].setAttribute('src', this.src) :
                this.$el.getElementsByClassName('ln-img-holder')[0].style.backgroundImage = `url(${this.src})`;
        }
        this.preloadImage();
    },
    render() {
        return vue.h('div', { class: this.classes }, this.genTemplate());
    }
});

var LnImageGallerySlideshow = vue.defineComponent({
    mixins: [styleable, utils],
    name: "LnImageGallerySlideshow",
    data() {
        return {
            id: this.genId(),
            imagesElements: [],
            index: this.modelValue,
            percentSwipe: 0,
            longTouch: false,
            clientXOffset: 0
        };
    },
    props: {
        images: {
            type: Array,
            required: true
        },
        lazyImages: {
            type: Array,
            required: false,
            default: []
        },
        modelValue: {
            type: Number,
            default: 0
        },
        aspectRatio: {
            type: String,
            default: '16/9'
        },
        nav: {
            type: Boolean,
            default: false
        },
        preview: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        touchStart(event) {
            for (let i = 0; i < this.imagesElements.length; i++) {
                this.imagesElements[i].classList.remove('ln-image-gallery-slideshow__image__transition');
            }
            this.longTouch = false;
            setTimeout(() => {
                this.longTouch = true;
            }, 250);
            this.clientXOffset = event.touches[0].clientX;
        },
        touchMove(event) {
            event.preventDefault();
            this.percentSwipe = (event.touches[0].clientX - this.clientXOffset) / window.innerWidth * 100;
            for (let i = 0; i < this.imagesElements.length; i++) {
                this.imagesElements[i].style.transform = `translateX(${((100 * i) - 100 * this.index) + this.percentSwipe}%)`;
            }
        },
        touchEnd() {
            for (let i = 0; i < this.imagesElements.length; i++) {
                this.imagesElements[i].classList.add('ln-image-gallery-slideshow__image__transition');
            }
            if (!this.longTouch) {
                if (this.percentSwipe < 0) {
                    this.index++;
                }
                else if (this.percentSwipe > 0) {
                    this.index--;
                }
            }
            else {
                for (let i = 0; i < this.imagesElements.length; i++) {
                    this.imagesElements[i].classList.add('ln-image-gallery-slideshow__image__transition');
                    this.imagesElements[i].style.transform = `translateX(${(100 * i) - 100 * this.index}%)`;
                }
            }
        },
        genTemplate() {
            return [
                vue.h('div', {}, [
                    this.genImageTemplates()
                ]),
                this.nav && vue.h(LnIcon, { class: 'ln-image-gallery-slideshow__nav__prev', onClick: () => { this.index--; } }, () => 'chevron-left'),
                this.nav && vue.h(LnIcon, { class: 'ln-image-gallery-slideshow__nav__next', onClick: () => { this.index++; } }, () => 'chevron-right'),
                this.preview && vue.h('div', { class: 'ln-image-gallery-slideshow__nav__preview' }, this.genPreview())
            ];
        },
        genImageTemplates() {
            return this.images.map((image) => {
                return vue.h(LnImage, {
                    class: ['ln-image-gallery-slideshow__image', 'ln-image-gallery-slideshow__image__transition'],
                    src: image,
                    lazySrc: this.lazyImages?.length === this.images.length ? this.lazyImages[this.images.indexOf(image)] : null,
                    asImg: true,
                    aspectRatio: this.aspectRatio,
                    height: '100%',
                    onTouchstart: this.touchStart,
                    onTouchmove: this.touchMove,
                    onTouchend: this.touchEnd
                }, () => []);
            });
        },
        genPreview() {
            return this.images.map((image) => {
                return vue.h(LnImage, {
                    class: 'ln-image-gallery-slideshow__nav__preview-image',
                    src: this.lazyImages?.length === this.images.length ? this.lazyImages[this.images.indexOf(image)] : image,
                    height: '100%',
                    width: '100%',
                    onClick: () => { this.index = this.images.indexOf(image); },
                    onTouchend: () => { this.index = this.images.indexOf(image); }
                });
            });
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'ln-image-gallery-slideshow': true,
                'ln-image-gallery-slideshow__nav': this.nav
            };
        }
    },
    watch: {
        index() {
            if (this.index < 0) {
                this.index = this.images.length - 1;
            }
            else if (this.index > this.images.length - 1) {
                this.index = 0;
            }
            for (let i = 0; i < this.imagesElements.length; i++) {
                this.imagesElements[i].style.transform = `translateX(${(100 * i) - 100 * this.index}%)`;
                if (this.preview) {
                    if (this.index === i) {
                        this.$el.getElementsByClassName('ln-image-gallery-slideshow__nav__preview-image')[i].style.transform = 'scale(1.3)';
                        this.$el.getElementsByClassName('ln-image-gallery-slideshow__nav__preview-image')[i].style.zIndex = 1;
                    }
                    else {
                        this.$el.getElementsByClassName('ln-image-gallery-slideshow__nav__preview-image')[i].style.transform = '';
                        this.$el.getElementsByClassName('ln-image-gallery-slideshow__nav__preview-image')[i].style.zIndex = '';
                    }
                }
            }
            this.$emit('update:modelValue', this.index);
        }
    },
    mounted() {
        this.$el.style.aspectRatio = this.aspectRatio;
        this.imagesElements = this.$el.getElementsByClassName('ln-image-gallery-slideshow__image');
        for (let i = 0; i < this.imagesElements.length; i++) {
            this.imagesElements[i].style.transform = `translateX(${(100 * i) - 100 * this.index}%)`;
        }
        if (this.preview) {
            this.$el.getElementsByClassName('ln-image-gallery-slideshow__nav__preview-image')[this.index].style.transform = 'scale(1.3)';
            this.$el.getElementsByClassName('ln-image-gallery-slideshow__nav__preview-image')[this.index].style.zIndex = 1;
        }
    },
    render() {
        return vue.h('div', { class: this.classes, id: this.id }, this.genTemplate());
    }
});

var LnRadioGroup = vue.defineComponent({
    mixins: [styleable, utils],
    name: "LnRadioGroup",
    data() {
        return {
            id: this.genId(),
            value: this.modelValue
        };
    },
    provide() {
        return {
            groupId: this.id,
            groupValue: vue.computed(() => this.modelValue),
            onGroupValueUpdate: (value) => { this.value = value; }
        };
    },
    props: {
        modelValue: {
            type: String
        },
        flow: {
            type: String,
            default: null,
            validator(value) {
                return ['column', 'column-reverse', 'row', 'row-reverse'].includes(value);
            }
        },
        align: {
            type: String,
            default: null,
            validator(value) {
                return ['start', 'center', 'end'].includes(value);
            }
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'ln-radio-group': true,
                [`ln-radio-group__${this.flow}`]: this.flow,
                [`ln-radio-group__align-${this.align}`]: this.align
            };
        }
    },
    watch: {
        value() {
            this.$emit('update:modelValue', this.value);
        }
    },
    render() {
        return vue.h('div', { class: this.classes }, [this.getDefaultSlot()]);
    }
});

var LnRadioButton = vue.defineComponent({
    mixins: [styleable, utils],
    name: "LnRadioButton",
    data() {
        return {
            groupId: vue.inject('groupId'),
            groupValue: vue.inject('groupValue'),
            onGroupValueUpdate: vue.inject('onGroupValueUpdate')
        };
    },
    props: {
        value: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        genTemplate() {
            return [
                vue.h('div', { class: this.isChecked ? 'ln-radio-button__checked' : '' }, []),
                vue.h('span', {}, [this.getDefaultSlot()])
            ];
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'ln-radio-button': true,
            };
        },
        isChecked() {
            return this.value === this.groupValue;
        }
    },
    mounted() {
        if (this.checked) {
            this.onGroupValueUpdate(this.value);
        }
    },
    render() {
        return vue.h('div', { class: this.classes, onClick: () => { this.onGroupValueUpdate(this.value); } }, this.genTemplate());
    }
});

var overlayable = {
    data() {
        return {
            overlay: document.createElement('div'),
            id: this.genId()
        };
    },
    props: {
        zIndex: {
            type: String,
            required: false,
            default: '100'
        }
    },
    methods: {
        createOverlay(zIndex) {
            const rootEl = document.querySelector('[ln-app]');
            this.overlay.classList.add('ln-overlay');
            this.overlay.style.zIndex = zIndex;
            this.overlay.addEventListener('click', () => {
                this.$emit('update:modelValue', false);
            });
            window.addEventListener('wheel', this.preventScroll, { passive: false });
            window.addEventListener('keydown', this.preventScroll, { passive: false });
            window.addEventListener('touchmove', this.preventScroll, { passive: false });
            rootEl && rootEl.insertBefore(this.overlay, rootEl.firstChild);
        },
        removeOverlay() {
            this.overlay.remove();
            document.body.removeAttribute('style');
            window.removeEventListener('wheel', this.preventScroll);
            window.removeEventListener('keydown', this.preventScroll);
            window.removeEventListener('touchmove', this.preventScroll);
        },
        preventScroll(e) {
            if (e.composedPath().map((x) => { return x.id; }).indexOf(this.id) > -1)
                return;
            if ('key' in e && ![33, 38, 34, 40].includes(e.keyCode)) {
                return;
            }
            e.preventDefault();
        },
    },
    watch: {
        modelValue() {
            if (!this.modelValue) {
                this.removeOverlay();
            }
        }
    }
};

var LnBurgerMenu = vue.defineComponent({
    mixins: [utils, styleable, overlayable],
    name: "LnBurgerMenu",
    data() {
        return {
            id: this.genId()
        };
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'ln-burger-menu': true,
                'ln-burger-menu__open': this.modelValue
            };
        }
    },
    watch: {
        modelValue() {
            if (this.modelValue) {
                this.createOverlay(this.zIndex);
            }
            else {
                this.removeOverlay();
            }
        }
    },
    mounted() {
        this.modelValue && this.createOverlay(this.zIndex);
    },
    render() {
        return vue.h('div', { class: this.classes, width: this.width, style: { zIndex: this.zIndex } }, this.getDefaultSlot());
    }
});

var LnCalendar = vue.defineComponent({
    mixins: [utils, styleable, gridable],
    name: "LnCalendar",
    data() {
        return {
            _dates: [],
            _date: this.date ? this.date : new Date(new Date().getFullYear(), new Date().getMonth() + this.monthOffset, new Date().getDate())
        };
    },
    props: {
        date: {
            type: Date,
            required: false
        },
        monthOffset: {
            type: Number,
            required: false,
            default: 0
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                ...this.gridableClasses,
                'ln-calendar': true
            };
        }
    },
    watch: {
        date() {
            this._date = this.date;
            this.buildCalendar();
        }
    },
    methods: {
        buildCalendar() {
            let _dates = [];
            let offset = this._date.getDate();
            let daysInMonth = new Date(this._date.getFullYear(), this._date.getMonth() + 1, 0).getDate();
            let weekday = this._date.getDay();
            let counter = 0;
            while (counter < offset || weekday !== 1) {
                let tmpDate = new Date(this._date.getFullYear(), this._date.getMonth(), this._date.getDate() - counter);
                weekday = tmpDate.getDay();
                _dates.push(tmpDate);
                counter++;
            }
            counter = offset + 1;
            while (counter <= daysInMonth || weekday !== 0) {
                let tmpDate = new Date(this._date.getFullYear(), this._date.getMonth(), this._date.getDate() + counter - offset);
                weekday = tmpDate.getDay();
                _dates.push(tmpDate);
                counter++;
            }
            this._dates = _dates.sort((x, y) => x.getTime() - y.getTime());
        },
        getCalenderPerWeek() {
            return Array(Math.ceil(this._dates.length / 7)).fill(0).map((_, index) => index * 7).map(begin => this._dates.slice(begin, begin + 7));
        },
        genTemplate() {
            return vue.h('div', { class: this.classes }, this.getCalenderPerWeek().map((week) => {
                return vue.h('div', { class: 'ln-calendar-week' }, week.map((date) => {
                    return this.$slots.default ? this.$slots.default({ date: date }) : this.genDefaultDayLayout(date);
                }));
            }));
        },
        genDefaultDayLayout(date) {
            return vue.h(LnCol, { class: { 'ln-calendar-day': true }, space: true }, () => date.getDate());
        }
    },
    mounted() {
        this.buildCalendar();
    },
    render() {
        return this.genTemplate();
    }
});

var LnDialog = vue.defineComponent({
    mixins: [utils, styleable, overlayable, gridable],
    name: "LnDialog",
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        height: {
            type: String || Number,
            default: null
        },
        width: {
            type: String || Number,
            default: null
        }
    },
    computed: {
        classes() {
            return {
                ...this.gridableClasses,
                ...this.styleableClasses,
                'ln-dialog': true,
                'ln-dialog__open': this.modelValue
            };
        }
    },
    watch: {
        modelValue() {
            if (this.modelValue) {
                this.createOverlay(this.zIndex);
            }
            else {
                this.removeOverlay();
            }
        }
    },
    mounted() {
        this.modelValue && this.createOverlay(this.zIndex);
    },
    render() {
        return vue.h('div', { class: this.classes, style: { zIndex: this.zIndex }, id: this.id }, this.getDefaultSlot());
    }
});

var LnCombobox = vue.defineComponent({
    mixins: [styleable, utils],
    name: "LnCombobox",
    data() {
        return {
            expanded: false,
            id: this.genId()
        };
    },
    props: {
        items: {
            type: Array,
            default: [],
            required: true
        },
        modelValue: {
            type: [String, Number, Array],
            default: []
        },
        multiple: Boolean,
        width: {
            default: '250px'
        },
        height: {
            default: '40px'
        },
        borderRadius: {
            default: '5px'
        },
        shadow: {
            default: true
        }
    },
    methods: {
        genTemplate() {
            return [
                vue.h('div', {
                    onClick: () => { this.expanded = !this.expanded; }
                }, [
                    this.genValue(),
                    vue.h(LnIcon, { class: 'ln-combobox__icon' }, () => 'menu-down')
                ]),
                vue.h('div', { class: { ...this.styleableClasses } }, this.genItems())
            ];
        },
        genValue() {
            if (this.modelValue) {
                if (typeof this.modelValue === "object") {
                    return this.modelValue.map((value) => {
                        return vue.h('span', {}, value);
                    });
                }
                else {
                    return [vue.h('span', {}, this.modelValue)];
                }
            }
            else {
                return [];
            }
        },
        genItems() {
            return this.items.map((item) => {
                return vue.h('div', {
                    style: { height: this._height },
                    onClick: () => {
                        if (!this.multiple) {
                            this.$emit('update:modelValue', item);
                            this.expanded = false;
                        }
                        else {
                            this.$emit('update:modelValue', this.computeValues(item));
                        }
                    }
                }, item);
            });
        },
        computeValues(item) {
            if (this.modelValue) {
                if (this.modelValue.indexOf(item) > -1) {
                    const newModelValue = this.modelValue;
                    newModelValue.splice(this.modelValue.indexOf(item), 1);
                    return newModelValue;
                }
                else {
                    return this.modelValue.concat([item]);
                }
            }
            else {
                return [item];
            }
        },
        onOutsideClick(e) {
            if (e.composedPath().map((x) => { return x.id; }).indexOf(this.id) < 0) {
                this.expanded = false;
            }
        }
    },
    computed: {
        classes() {
            return {
                ...this.styleableClasses,
                'ln-combobox': true,
                'ln-combobox__expanded': this.expanded
            };
        }
    },
    mounted() {
        window.addEventListener('click', this.onOutsideClick);
    },
    unmounted() {
        window.removeEventListener('click', this.onOutsideClick);
    },
    render() {
        return vue.h('div', { class: this.classes, id: this.id }, this.genTemplate());
    }
});

// This is just for local testing //
try {
    require('./index.css');
}
catch {
}
const LnMaterialsPlugin = {
    install(app, options) {
        app.config.globalProperties.$primaryColor = options.primaryColor;
        app.config.globalProperties.$accentColor = options.accentColor;
        app.config.globalProperties.$interactionColor = options.interactionColor;
        app.component('LnContainer', LnContainer);
        app.component('LnRow', LnRow);
        app.component('LnCol', LnCol);
        app.component('LnSpacer', LnSpacer);
        app.component('LnButton', LnButton);
        app.component('LnFileSelector', LnFileSelector);
        app.component('LnTextBox', LnTextBox);
        app.component('LnFooter', LnFooter);
        app.component('LnHeader', LnHeader);
        app.component('LnIcon', LnIcon);
        app.component('LnImage', LnImage);
        app.component('LnImageGallerySlideshow', LnImageGallerySlideshow);
        app.component('LnRadioGroup', LnRadioGroup);
        app.component('LnRadioButton', LnRadioButton);
        app.component('LnBurgerMenu', LnBurgerMenu);
        app.component('LnApp', LnApp);
        app.component('LnCalendar', LnCalendar);
        app.component('LnDialog', LnDialog);
        app.component('LnCombobox', LnCombobox);
        let css = `:root { --primary-color: ${options.primaryColor};
                           --accent-color: ${options.accentColor};
                           --interaction-color: ${options.interactionColor};
                           --text-color: ${options.textColor};
                           --fontFamily: ${options.fontFamily};}
                    body, html {
                        color: ${options.textColor};
                        margin: 0;
                        padding: 0;
                        font-family: ${options.fontFamily};
                        font-weight: ${options.fontWeight};
                    }`;
        let head = document.getElementsByTagName('head')[0];
        let style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);
        app.config.unwrapInjectedRef = true;
    }
};

exports.LnApp = LnApp;
exports.LnBurgerMenu = LnBurgerMenu;
exports.LnButton = LnButton;
exports.LnCalendar = LnCalendar;
exports.LnCol = LnCol;
exports.LnCombobox = LnCombobox;
exports.LnContainer = LnContainer;
exports.LnDialog = LnDialog;
exports.LnFileSelector = LnFileSelector;
exports.LnFooter = LnFooter;
exports.LnHeader = LnHeader;
exports.LnIcon = LnIcon;
exports.LnImage = LnImage;
exports.LnImageGallerySlideshow = LnImageGallerySlideshow;
exports.LnMaterialsPlugin = LnMaterialsPlugin;
exports.LnRadioButton = LnRadioButton;
exports.LnRadioGroup = LnRadioGroup;
exports.LnRow = LnRow;
exports.LnSpacer = LnSpacer;
exports.LnTextBox = LnTextBox;
